






















































import { Component, Vue } from "vue-property-decorator";
import { GetTemplateInfo } from "@/services/templates/templateService";
import { TemplateInfo } from "@/services/templates/types";

@Component
export default class TemplateInfoModal extends Vue {
    templateInfo = {} as TemplateInfo;

    open(templateId: string) {
        GetTemplateInfo(templateId).then(response => {
            this.templateInfo = response;
            this.$bvModal.show("modal-templateInfo");
        });
    }

    settingsSolution(id: string) {
        return {
            name: "updateSolution",
            params: { solutionId: id }
        };
    }

    settingsStage(id: string) {
        return {
            name: "updateStage",
            params: { stageId: id }
        };
    }

    hide() {
        this.$bvModal.hide("modal-templateInfo");
    }
}
